












import Vue from 'vue';
import Component from 'vue-class-component';
import { Getter, Mutation } from 'vuex-class';
import { INotification } from '@/models';

@Component
export default class Notifications extends Vue {
  @Getter('notifications', { namespace: 'notification' })
  notifications: INotification[];
  @Mutation('closeNotification', { namespace: 'notification' }) close: (
    id: number,
  ) => void;
}
